import faunadb from 'faunadb';

const key = 'fnAEn_9GH6ACUIx7TGg4hA4_syuuBSean-1_sbgP';
const q = faunadb.query;
const client = new faunadb.Client({
  secret: key,
  domain: 'db.fauna.com', // Adjust if you are using Region Groups
});

const refs = {};

const set = async (collection, key, value) => {
  if(refs[collection] == null) {
    await get(collection, key);
  }
  try {
    await client.query(
      q.Replace(
        refs[collection],
        { data: { key, value } }
      )
    );
  } catch (e) {
    await client.query(
      q.Create(
        q.Collection(collection),
        { data: { key, value } }
      )
    );
  }
};

const get = async (collection, key) => {
  try {
    const result = await client.query(
      q.Get(
        q.Match(q.Index(`${collection}-by-key`), key)
      )
    );
    refs[collection] = result.ref;
    return result?.data?.value;
  } catch (e) {
    return null;
  }
};

export default { get, set };

// https://www.thisdb.com/
//
// const bucket = 'HlUcebkPmDROynIK1MrpLNth';
// const token = '7ca099a3192d4de8e2bef6a3590a15e5e6746e0b';
// const prefix = 'colormatcher:';
//
// const set = async (key, value) => {
//   let headers = {
//     'X-Token': token,
//   };
//   let init = {
//     headers,
//     method: 'POST',
//     body: value,
//   };
//   let response = await fetch(`https://api.thisdb.com/v1/${bucket}/${prefix}${key}`, init);
//   return await response.text();
// };
//
// const get = async (key) => {
//   let headers = {
//     'X-Token': token,
//   };
//   let init = {
//     headers,
//     method: 'GET'
//   };
//   let response = await fetch(`https://api.thisdb.com/v1/${bucket}/${prefix}${key}`, init);
//   if (response.status != 200) {
//     throw 'key does not exist.';
//   }
//   return await response.text();
// };
//
// export default { get, set };
